<template>
   <div>
        <v-dialog v-model="addPaymentShow" max-width="440" persistent>
            <v-card outlined
                :class="`p-4 font-Nunito !bg-[#00000047] backdrop-blur-sm !rounded-xl !border-[2px] ${routeLink ? routeLink + '-border' : 'straight-border'}`">
                <div class="absolute right-3 top-3">
                    <v-icon @click.prevent="$emit('closeAddPayment')"
                        :color="routeLink ? colorAsRoute : '#a07a1d'">mdi-window-close</v-icon>
                </div>
                <v-card-title
                    :class="`!text-center font-Handel !uppercase font-bold ${routeLink ? routeLink : 'straight'}_fortext justify-center`">Add
                    Payment Method</v-card-title>
    
                <v-form v-model="isFormValid">
                    <div class="flex flex-col gap-x-3">
                        <div>
                            <label class="text-white">Card Holder's Name*</label>
                            <v-text-field color="" solo v-model="cardHolderName" :rules="[v => !!v || 'Name is required']" />
                        </div>
                        <div>
                            <label class="text-white">Card Number*</label>
                            <v-text-field color="" solo class="card_number" v-model="cardNumber"
                                :rules="[v => !!v || 'Card Number is required']" v-cardformat:formatCardNumber
                                @change="identifyIcon">
                                <template v-slot:append>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <Icon class="text-4xl" v-on="on" :icon="computedIcon" />
                                            <!-- <v-icon >
                                                {{computedIcon}}
                                            </v-icon> -->
                                        </template>
                                        I'm a tooltip
                                    </v-tooltip>
                                </template></v-text-field>
                        </div>
                        <div class="flex gap-x-3">
                            <div class="w-1/2">
                                <label class="text-white">Expires at*</label>
                                <v-text-field color="" solo v-model="cardExpiry"
                                    :rules="[v => !!v || 'Card Expiry Date is required']" v-cardformat:formatCardExpiry
                                    prepend-icon="" />
                            </div>
                            <div class="w-1/2">
                                <label class="text-white">CVC*</label>
                                <v-text-field color="" solo v-model="cardCvc" :rules="[v => !!v || 'Card CVC is required']"
                                    v-cardformat:formatCardCVC prepend-icon="" />
                            </div>
                        </div>
                        <div class="flex justify-end">
                            <v-btn :loading="loading" type="submit" :color="routeLink ? colorAsRoute : '#a07a1d'" small outlined
                                :disabled="!isFormValid" @click.prevent="addPaymentMethod()">Add Payment Method</v-btn>
                        </div>
                    </div>
                </v-form>
            </v-card>
        </v-dialog>
        <PaymentAddedSubscribe :showCheckout="showCheckOut"    @closePaymentAddedDialog="showCheckOut = false"  />
   </div>
</template>
  
<script>
import { Icon } from '@iconify/vue2';
import InputFieldCreditCard from './InputFieldCreditCard.vue';
import axios from 'axios';
import PaymentAddedSubscribe from './PaymentAddedSubscribe.vue';



export default {
    components: { InputFieldCreditCard, Icon, PaymentAddedSubscribe },

    props: {
        addPaymentShow: Boolean,
       
    },
    data() {
        return {
            cardElement: null,
            iconIdentity: '',
            cardNumber: '',
            formatCardExpiry: '',
            cardExpiry: '',
            cardCvc: '',
            cardHolderName: '',
            loading: false,


            // validation 
            isFormValid: false,

            //checkout 
            showCheckOut : false,
            payNowLoading  :false


        };
    },
    computed: {
        computedIcon() {
            if (this.iconIdentity !== '') {
                return `logos:${this.iconIdentity}`
            } else {
                return 'noto:credit-card'
            }

        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },
    },
    methods: {
        identifyIcon() {
            const inputCardNumber = document.querySelector('.card_number input').classList;
            if (inputCardNumber.contains('visa')) {
                this.iconIdentity = 'visa'
            } else if (inputCardNumber.contains('mastercard')) {
                this.iconIdentity = 'mastercard'
            } else if (inputCardNumber.contains('amex')) {
                this.iconIdentity = 'amex'
            } else if (inputCardNumber.contains('unionpay')) {
                this.iconIdentity = 'unionpay'
            } else if (inputCardNumber.contains('discover')) {
                this.iconIdentity = 'discover'
            } else if (inputCardNumber.contains('dinersclub')) {
                this.iconIdentity = 'dinersclub'
            } else if (inputCardNumber.contains('jcb')) {
                this.iconIdentity = 'jcb'
            }
        },
        
        async addPaymentMethod() {

            var formdata = new FormData();
            formdata.append("type", "card");
            formdata.append("card['number']", this.cardNumber);
            formdata.append("card['exp_month']", this.cardExpiry.split(' ')[0]);
            formdata.append("card['exp_year']", this.cardExpiry.split(' ')[2]);
            formdata.append("card['cvc']", this.cardCvc);
            formdata.append("card['name']", this.cardHolderName);
            try {
                this.loading = true;
                const data = await axios.post('user/payments', formdata);
                if (data.status == 200) {
                    const { data } = await axios.get('profiles')
                    this.$store.commit("setUser", data);
                    if (this.$route.path == '/plan') {
                        // this.subscribePackage()
                        this.$emit('closeAddPayment')
                        this.showCheckOut = true;
                    } else {
                        this.$emit('closeAddPayment')
                    }
                    this.$toast(`Payment Method has been updated`, {
                        position: "top-left",
                        timeout: 3000,
                        closeOnClick: true,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 0.6,
                        showCloseButtonOnHover: false,
                        hideProgressBar: false,
                        closeButton: "button",
                        icon: {
                            iconClass: "mdi mdi-alert-circle-outline",
                            iconChildren: "",
                            iconTag: "i"
                        },
                        rtl: false
                    });

                }

            } catch (error) {
                console.error(error.response.data.message)
                this.$toast(`${error.response.data.message}`, {
                    position: "top-left",
                    timeout: 3000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: false,
                    closeButton: "button",
                    icon: {
                        iconClass: "mdi mdi-alert-circle-outline",
                        iconChildren: "",
                        iconTag: "i"
                    },
                    rtl: false
                });
            } finally {
                this.loading = false;
            }
        }
    },
    mounted() {


    },
    created() {
    },
    watch: {
        cardNumber: {
            handler() {
                this.identifyIcon();
            }
        }
    },

};
</script>
  
<style scoped>
/* Use Tailwind classes to style the form */

.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}

.form_input:deep(.v-text-field--outlined fieldset) {
    top: 0;
}

.card_number:deep(.v-input__append-inner) {
    max-width: 50px;
}
</style>
  